import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as GovernanceAction from './actions';
import { GovernanceService } from "./service";

@Injectable()
export class GovernanceEffect {

    constructor(
        private action: Actions,
        private governanceService: GovernanceService
    ) { }

    GetGovernanceList = createEffect(() => this.action.pipe(
        ofType(type.GET_GOVERNANCE_LIST),
        switchMap((data) => this.governanceService.getGovernanceList()),
        map((data: Array<any>) => new GovernanceAction.GovernanceList(data)
        )
    ));

    GovernanceById = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_GOVERNANCE_BY_ID),
        switchMap((data: any) => this.governanceService.getGovernanceById(data.payload)),
        map((data: Array<any>) => new GovernanceAction.GovernanceById(data)
        )
    ));

    AddGovernance = createEffect(() => this.action.pipe(
        ofType(type.ADD_GOVERNANCE),
        switchMap((data: any) => this.governanceService.addGovernance(data.payload)),
        map((data: any) => new GovernanceAction.AddGovernanceResponse(data)
        )
    ));

    UpdateGovernance = createEffect(() => this.action.pipe(
        ofType(type.UPDATE_GOVERNANCE),
        switchMap((data: any) => this.governanceService.updateGovernance(data.payload)),
        map((data: any) => new GovernanceAction.UpdateGovernanceResponse(data)
        )
    ));

    DeleteGovernance = createEffect(() => this.action.pipe(
        ofType(type.DELETE_GOVERNANCE),
        switchMap((data: any) => this.governanceService.deleteGovernance(data.payload)),
        map((data: any) => new GovernanceAction.DeleteGovernanceResponse(data)
        )
    ));

    SearchGovernanceByFields = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_GOVERNANCE_BY_FIELD),
        switchMap((data: any) => this.governanceService.searchGovernanceByFields(data.payload)),
        map((data) => new GovernanceAction.GovernanceByFieldList(data)
        )
    ));

    ValidateStartDate = createEffect(() => this.action.pipe(
        ofType(type.VALIDATE_START_DATE),
        switchMap((data: any) => this.governanceService.validateStartDate(data.payload)),
        map((data) => new GovernanceAction.ValidateStartDateResp(data)
        )
    ));

}
